import { Size, useWindowSize } from 'hooks/useWindowSize';
import { useEffect, useState } from 'react';
import { isMobileWidth } from 'utils/helpers';
import { VideoJsPlayer, VideoJsPlayerOptions } from 'video.js';
import { BlocksMediaType } from '../mediaBlock/MediaBlock';
import style from './VideoBlock.module.scss';
import { VideoJSPlayer } from './VideoJSPlayer';

export type VideoBlockType = BlocksMediaType &
  Required<Pick<BlocksMediaType, 'video'>> &
  Pick<VideoJsPlayerOptions, 'controls' | 'autoplay' | 'loop'>;

export const VideoBlock = (props: VideoBlockType): JSX.Element => {
  const [isMobileDevice, setIsMobileDevice] = useState<boolean>(false);
  const size: Size = useWindowSize();

  useEffect(() => {
    setIsMobileDevice(isMobileWidth(size.width));
  }, [size]);

  const poster = isMobileDevice && props.phone_image ? props.phone_image : props.image;
  const src = isMobileDevice && props.phone_video ? props.phone_video : props.video;

  const videoJsOptions: VideoJsPlayerOptions = {
    // lookup the options in the docs for more options
    responsive: true,
    controlBar: props.controls ? {} : false,

    controls: true,
    bigPlayButton: !props.autoplay,
    loop: props.loop,
    autoplay: props.autoplay,
    muted: props.autoplay,

    fill: true,
    preload: 'auto',
    userActions: {
      doubleClick: false,
    },
    poster: poster,
    sources: [
      {
        src: src,
      },
    ],
  };

  const onReady = (player: VideoJsPlayer) => {};

  const dimensionsOfPoster = {
    w: isMobileDevice && props.phone_image ? props.phone_image_width : props.image_width,
    h: isMobileDevice && props.phone_image ? props.phone_image_height : props.image_height,
  };

  let aspectRatioOfVideo = 100 + '%';
  if (dimensionsOfPoster && dimensionsOfPoster.h && dimensionsOfPoster.w) {
    aspectRatioOfVideo = (dimensionsOfPoster.h / dimensionsOfPoster.w) * 100 + '%';
  }

  const containerStyle = { paddingTop: aspectRatioOfVideo };
  return (
    <div className={`${style.blockContainer} block-video`}>
      <div className={style.aspectContainer} style={containerStyle}>
        <VideoJSPlayer playsInline={true} options={videoJsOptions} onReady={onReady} />
      </div>
    </div>
  );
};
